<template>
  <header class="border-b border-gray-200 bg-white relative">
      <div class="mx-auto max-w-[1450px] px-8 lg:px-12 flex py-3 items-center justify-between">

      <!-- Logo -->
      <router-link to="/" class="flex items-center gap-2">
        <img
            src="/Singapore-Top-Souvenir-Award-Logo.png"
            alt="Souvenir Excellence Awards Logo"
            class="h-10 md:h-12 w-auto"
        />
        <span class="font-serif text-lg font-semibold text-[#7c2622] tracking-tight">
          Souvenir Excellence Awards
        </span>
      </router-link>

      <!-- Desktop Nav -->
      <nav class="hidden md:flex items-center gap-8">
        <router-link
          v-for="link in navLinks"
          :key="link.path"
          :to="link.path"
          :class="[
            'text-sm transition-colors',
            $route.path === link.path
              ? 'text-[#7c2622] font-medium'
              : 'text-gray-600 hover:text-[#7c2622]'
          ]"
        >
          {{ link.label }}
        </router-link>

        <!-- <router-link
          to="/apply"
          class="bg-[#7c2622] text-white px-4 py-2 text-sm font-medium hover:bg-[#671f1c] transition-colors"
        >
          Apply Now
        </router-link> -->
      </nav>

      <!-- Mobile Button -->
      <button
        class="md:hidden text-[#7c2622]"
        @click="mobileOpen = !mobileOpen"
      >
        <svg
          v-if="!mobileOpen"
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"/>
        </svg>

        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <!-- Mobile Menu -->
    <div
      v-if="mobileOpen"
      class="md:hidden bg-white border-t border-gray-200"
    >
      <div class="flex flex-col px-6 py-4 space-y-4">
        <router-link
          v-for="link in navLinks"
          :key="link.path"
          :to="link.path"
          @click="mobileOpen = false"
          :class="[
            'text-sm transition-colors',
            $route.path === link.path
              ? 'text-[#7c2622] font-medium'
              : 'text-gray-700 hover:text-[#7c2622]'
          ]"
        >
          {{ link.label }}
        </router-link>

        <!-- <router-link
          to="/apply"
          @click="mobileOpen = false"
          class="bg-[#7c2622] text-white px-4 py-2 text-sm font-medium hover:bg-[#671f1c] transition-colors text-center"
        >
          Apply Now
        </router-link> -->
      </div>
    </div>

  </header>
</template>

<script>
export default {
  name: "PageHeader",
  data() {
    return {
      mobileOpen: false,
      navLinks: [
        { label: "About", path: "/about" },
        { label: "Categories", path: "/categories" },
        { label: "Judging", path: "/judging" },
        { label: "Recipients", path: "/recipients" },
        { label: "Timeline", path: "/timeline" },
      ],
    }
  },
}
</script>